<template lang="html">
  <v-layout
    align-center
    ma-0
  >
    <v-flex
      v-if="dividerLeft && !isActive"
      xs12
    >
      <v-divider />
    </v-flex>
    <v-spacer v-if="right" />
    <v-flex
      v-if="isActive"
      xs12
    >
      <v-text-field
        ref="input"
        v-model="internalValue"
        :label="variableTerm"
        single-line
        autofocus
        :prefix="prefix"
        :rules="[validateVariable, validateNotExists]"
        :counter="(internalValue || '').length < minLength ? minLength : false"
        :append-icon="isValid ? 'done' : validateVariable(internalValue) !== true ? 'close' : '' "
        :success="isValid"
        :messages="messages"
        @keydown.enter="handleEnter"
        @keydown.esc="close"
      />
    </v-flex>
    <v-btn
      v-if="isActive"
      color="grey"
      text
      @click="close"
    >
      cancel
    </v-btn>
    <v-btn
      v-if="isActive"
      color="primary"
      text
      :disabled="!isValid"
      @click="emitVariable()"
    >
      Create
    </v-btn>
    <v-btn
      v-if="!isActive"
      color="primary"
      text
      @click="internalActive = true"
    >
      <v-icon left>
        add
      </v-icon>Add
    </v-btn>
    <v-flex
      v-if="dividerRight && !isActive"
      xs12
    >
      <v-divider />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    variableTerm: {
      type: String,
      default: 'Variable'
    },
    prefix: {
      type: String,
      default: ''
    },
    existingVariables: {
      type: Object,
      default: () => { return {} }
    },
    right: Boolean,
    active: Boolean,
    dividerLeft: Boolean,
    dividerRight: Boolean,
    allowExplicit: Array,
    regex: {
      type: String,
      default: '^[a-z0-9_]*$'
    },
    regexErrorText: String,
    minLength: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      internalValue: '',
      internalActive: false,
      saving: false
    }
  },
  computed: {
    isActive () {
      return this.active || this.internalActive
    },
    isValid () {
      return (this.internalValue || '').length >= this.minLength && this.validateVariable(this.internalValue) === true && this.validateNotExists(this.internalValue) === true
    },
    messages () {
      var m = []
      if ((this.internalValue || '').substring(0, 1) === '_') m.push('"_" variables are persistent and will not be removed durring data resets')
      if ((this.internalValue || '').substring(0, 5) === 'error') m.push('"error" variables will disable a calculation if they return true')
      return m
    }
  },
  watch: {
    internalActive (v) {
      requestAnimationFrame(() => {
        if (v && !this.active) this.focus()
      })
    }
  },
  methods: {
    validateVariable (str) {
      if ((this.allowExplicit || []).includes(str)) return true
      var regex = RegExp(this.regex)
      return regex.test(str) || (this.regexErrorText ? this.regexErrorText : `${this.variableTerm} must be all lower case and only contain letters (a-z), numbers (0-9) or underscore (_)`)
    },
    validateNotExists (str) {
      return !this.existingVariables[this.prefix + str] || `${this.variableTerm} is already in use`
    },
    close () {
      this.$emit('cancel')
      this.internalActive = false
      this.internalValue = ''
      this.$refs.input.reset()
    },
    emitVariable () {
      this.$emit('variable', `${this.prefix}${this.internalValue}`)
      this.close()
    },
    focus () {
      this.$refs.input.focus()
    },
    reset () {
      this.$refs.input.reset()
    },
    handleEnter () {
      if (this.isValid) this.emitVariable()
    }
  }
}
</script>

<style lang="css" scoped>
</style>
